import React from "react";

const SBox = ({ sBoxNumber, inputBits }) => {
  // Define the S-boxes
  //<SBox sBoxNumber={0} inputBits="000000" /> use this component like this

  const SBoxes = [
    [
      [14, 4, 13, 1, 2, 15, 11, 8, 3, 10, 6, 12, 5, 9, 0, 7],
      [0, 15, 7, 4, 14, 2, 13, 1, 10, 6, 12, 11, 9, 5, 3, 8],
      [4, 1, 14, 8, 13, 6, 2, 11, 15, 12, 9, 7, 3, 10, 5, 0],
      [15, 12, 8, 2, 4, 9, 1, 7, 5, 11, 3, 14, 10, 0, 6, 13],
    ],
    [
        [15, 1, 8, 14, 6, 11, 3, 4, 9, 7, 2, 13, 12, 0, 5, 10],
        [3, 13, 4, 7, 15, 2, 8, 14, 12, 0, 1, 10, 6, 9, 11, 5],
        [0, 14, 7, 11, 10, 4, 13, 1, 5, 8, 12, 6, 9, 3, 2, 15],
        [13, 8, 10, 1, 3, 15, 4, 2, 11, 6, 7, 12, 0, 5, 14, 9],
      ], //sbox2

      [
        [10, 0, 9, 14, 6, 3, 15, 5, 1, 13, 12, 7, 11, 4, 2, 8],
        [13, 7, 0, 9, 3, 4, 6, 10, 2, 8, 5, 14, 12, 11, 15, 1],
        [13, 6, 4, 9, 8, 15, 3, 0, 11, 1, 2, 12, 5, 10, 14, 7],
        [1, 10, 13, 0, 6, 9, 8, 7, 4, 15, 14, 3, 11, 5, 2, 12],
      ], //sbox3

      [
        [7, 13, 14, 3, 0, 6, 9, 10, 1, 2, 8, 5, 11, 12, 4, 15],
        [13, 8, 11, 5, 6, 15, 0, 3, 4, 7, 2, 12, 1, 10, 14, 9],
        [10, 6, 9, 0, 12, 11, 7, 13, 15, 1, 3, 14, 5, 2, 8, 4],
        [3, 15, 0, 6, 10, 1, 13, 8, 9, 4, 5, 11, 12, 7, 2, 14],
      ], //sbox4

      [
        [2, 12, 4, 1, 7, 10, 11, 6, 8, 5, 3, 15, 13, 0, 14, 9],
        [14, 11, 2, 12, 4, 7, 13, 1, 5, 0, 15, 10, 3, 9, 8, 6],
        [4, 2, 1, 11, 10, 13, 7, 8, 15, 9, 12, 5, 6, 3, 0, 14],
        [11, 8, 12, 7, 1, 14, 2, 13, 6, 15, 0, 9, 10, 4, 5, 3],
      ], //sbox5

      [
        [12, 1, 10, 15, 9, 2, 6, 8, 0, 13, 3, 4, 14, 7, 5, 11],
        [10, 15, 4, 2, 7, 12, 9, 5, 6, 1, 13, 14, 0, 11, 3, 8],
        [9, 14, 15, 5, 2, 8, 12, 3, 7, 0, 4, 10, 1, 13, 11, 6],
        [4, 3, 2, 12, 9, 5, 15, 10, 11, 14, 1, 7, 6, 0, 8, 13],
      ], //sbox6

      [
        [4, 11, 2, 14, 15, 0, 8, 13, 3, 12, 9, 7, 5, 10, 6, 1],
        [13, 0, 11, 7, 4, 9, 1, 10, 14, 3, 5, 12, 2, 15, 8, 6],
        [1, 4, 11, 13, 12, 3, 7, 14, 10, 15, 6, 8, 0, 5, 9, 2],
        [6, 11, 13, 8, 1, 4, 10, 7, 9, 5, 0, 15, 14, 2, 3, 12],
      ], //sbox7

      [
        [13, 2, 8, 4, 6, 15, 11, 1, 10, 9, 3, 14, 5, 0, 12, 7],
        [1, 15, 13, 8, 10, 3, 7, 4, 12, 5, 6, 11, 0, 14, 9, 2],
        [7, 11, 4, 1, 9, 12, 14, 2, 0, 6, 10, 13, 15, 3, 5, 8],
        [2, 1, 14, 7, 4, 10, 8, 13, 15, 12, 9, 0, 3, 5, 6, 11],
      ], //sbox8
  ];

  // Validate the S-box number
  if (sBoxNumber < 0 || sBoxNumber >= SBoxes.length) {
    return <div>Error: Invalid S-box number</div>;
  }

  // Calculate row and column indexes from the input bits
  const row = parseInt(inputBits.substring(0, 1) + inputBits.substring(5, 6), 2);
  const col = parseInt(inputBits.substring(1, 5), 2);

  // Get the S-box output value
  const sBoxValue = SBoxes[sBoxNumber][row][col].toString(2).padStart(4, "0");

  return (
    <div className="p-4 bg-gray-100 rounded-lg shadow-md">
      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr>
            {Array.from({ length: 16 }, (_, index) => (
              <th key={index} className="border p-2">
                {index.toString(2).padStart(4, "0")}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {SBoxes[sBoxNumber].map((rowValues, rowIndex) => (
            <tr
              key={rowIndex}
              className={rowIndex === row ? "bg-blue-200" : ""}
            >
              {rowValues.map((value, colIndex) => (
                <td
                  key={colIndex}
                  className={colIndex === col ? "bg-blue-200" : ""}
                >
                  {value.toString(2).padStart(4, "0")}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="text-sm mt-2">
        Selected Row: {row.toString(2).padStart(2, "0")}
      </div>
      <div className="text-sm mt-2">
        Selected Column: {col.toString(2).padStart(4, "0")}
      </div>
      <div className="text-sm mt-2">
        S-Box Output: {sBoxValue}
      </div>
    </div>
  );
};

export default SBox;
